export const CORNER_STYLE = 'circle'
export const BORDER_COLOR = '#C00000'
export const CORNER_COLOR = '#C00000'
export const CORNER_STROKE_COLOR = '#FFF'
export const TRANSPARENT_CORNERS = false
export const CANVAS_WIDTH = 1570
export const CANVAS_HEIGHT = 912
export const VIEWPORT_TRANSFORM = [1, 0, 0, 1, 0, 0]
